import { render, staticRenderFns } from "./multiUserTable.vue?vue&type=template&id=5b4516f0"
import script from "./multiUserTable.vue?vue&type=script&lang=js"
export * from "./multiUserTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports